import { render, staticRenderFns } from "./RevenueAdd.vue?vue&type=template&id=7585bd22&scoped=true&"
import script from "./RevenueAdd.vue?vue&type=script&lang=js&"
export * from "./RevenueAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7585bd22",
  null
  
)

export default component.exports